import { AppSidebar } from "@/components/app-sidebar";
import { UserNav } from "@/components/common/user-nav";
import { PathBreadcrumbs } from "@/components/path-breadcrumbs";
import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from "@/components/ui/sidebar";
import { profileQueryHooks } from "@/hooks/queryHooks";
import { Separator } from "@radix-ui/react-separator";
import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/dashboard")({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();
  const { data: profileResponse } = profileQueryHooks.useGetUserProfile();

  useEffect(() => {
    // Redirect "Komisi" users to /dashboard/komisi
    if (profileResponse?.data?.role?.name === "Komisi") {
      // Check if we're already at the komisi route to prevent redirect loops
      if (window.location.pathname === "/dashboard") {
        navigate({ to: "/dashboard/komisi" });
      }
    }
  }, [profileResponse, navigate]);

  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
        <header className="flex h-16 shrink-0 items-center gap-2 justify-between">
          <div className="flex items-center gap-2 px-4">
            <SidebarTrigger className="-ml-1" />
            <Separator
              orientation="vertical"
              className="mr-2 data-[orientation=vertical]:h-4"
            />
            <PathBreadcrumbs />
          </div>
          <div className="flex items-center gap-3 p-6">
            {/* <ModeToggle /> */}
            <UserNav />
          </div>
        </header>

        <main className="flex flex-1 flex-col gap-4 p-4 pt-0">
          <Outlet />
        </main>
      </SidebarInset>
    </SidebarProvider>
  );
}
